/*!
 * Edible Growth — EGModals
 * Premium ingredient, benefit, and science popup system.
 * Defines window.EGModals used site-wide by product and education pages.
 */
(function () {
  'use strict';

  /* ── Inject premium CSS for molecule + benefit panels ─────────── */
  var s = document.createElement('style');
  s.id = 'eg-modals-premium';
  s.textContent =

    /* ── Backdrop ── */
    '#eg-modal-molecule,#eg-modal-benefit{' +
      'background:rgba(0,0,0,0.76) !important;' +
      'backdrop-filter:blur(14px) !important;' +
      '-webkit-backdrop-filter:blur(14px) !important;' +
    '}' +

    /* ── Molecule panel ── */
    '#eg-modal-molecule-panel{' +
      'background:rgba(7,10,18,0.94) !important;' +
      'backdrop-filter:blur(22px) !important;' +
      '-webkit-backdrop-filter:blur(22px) !important;' +
      'border:1px solid rgba(255,255,255,0.09) !important;' +
      'border-radius:1.5rem !important;' +
      'padding:0 !important;' +
      'max-width:34rem !important;' +
      'overflow:hidden;' +
    '}' +

    /* ── Benefit panel ── */
    '#eg-modal-benefit-panel{' +
      'background:rgba(7,10,18,0.94) !important;' +
      'backdrop-filter:blur(22px) !important;' +
      '-webkit-backdrop-filter:blur(22px) !important;' +
      'border:1px solid rgba(255,255,255,0.09) !important;' +
      'border-radius:1.5rem !important;' +
      'padding:0 !important;' +
      'max-width:38rem !important;' +
      'overflow:hidden;' +
    '}' +

    /* ── Science panel inner padding ── */
    '#eg-modal-science-panel{padding:0 !important;}' +

    /* ── Entrance animation ── */
    '#eg-modal-molecule .eg-modal-panel,' +
    '#eg-modal-benefit .eg-modal-panel,' +
    '#eg-modal-science .eg-modal-panel{' +
      'transform:scale(0.96) translateY(14px);' +
      'transition:transform 0.44s cubic-bezier(0.16,1,0.3,1),opacity 0.32s ease;' +
    '}' +
    '#eg-modal-molecule.is-open .eg-modal-panel,' +
    '#eg-modal-benefit.is-open .eg-modal-panel,' +
    '#eg-modal-science.is-open .eg-modal-panel{transform:scale(1) translateY(0);}' +

    /* ── Inner wrapper ── */
    '.egm-inner{padding:1.75rem;position:relative;}' +

    /* ── Close button ── */
    '.egm-close{' +
      'position:absolute;top:1.1rem;right:1.1rem;' +
      'width:2.25rem;height:2.25rem;' +
      'display:flex;align-items:center;justify-content:center;' +
      'background:rgba(255,255,255,0.07);' +
      'border:1px solid rgba(255,255,255,0.11);' +
      'border-radius:9999px;' +
      'color:rgba(255,255,255,0.55);' +
      'cursor:pointer;' +
      'transition:background 0.2s,color 0.2s,box-shadow 0.2s;' +
      'z-index:3;flex-shrink:0;' +
    '}' +
    '.egm-close:hover{' +
      'background:rgba(255,255,255,0.13);' +
      'color:#fff;' +
      'box-shadow:0 0 12px rgba(255,255,255,0.10);' +
    '}' +


    /* ── Header ── */
    '.egm-header{' +
      'display:flex;align-items:center;gap:0.75rem;' +
      'margin-bottom:1rem;padding-right:2.5rem;' +
    '}' +
    '.egm-dot{' +
      'width:0.8rem;height:0.8rem;border-radius:9999px;flex-shrink:0;' +
    '}' +
    '.egm-title{' +
      'font-size:1.45rem;font-weight:800;color:#fff;' +
      'line-height:1.2;margin:0;letter-spacing:-0.01em;' +
    '}' +

    /* ── Body copy ── */
    '.egm-desc{' +
      'font-size:0.875rem;color:rgba(255,255,255,0.65);' +
      'line-height:1.68;margin:0 0 1.2rem;' +
    '}' +

    /* ── WIIFM card ── */
    '.egm-wiifm{' +
      'background:rgba(255,255,255,0.04);' +
      'border:1px solid rgba(255,255,255,0.07);' +
      'border-left:3px solid var(--mc,rgba(96,165,250,0.85));' +
      'border-radius:0.75rem;' +
      'padding:0.875rem 1rem;' +
    '}' +
    '.egm-wiifm-label{' +
      'font-size:0.625rem;font-weight:900;letter-spacing:0.13em;' +
      'text-transform:uppercase;' +
      'color:var(--mc,rgba(96,165,250,0.9));' +
      'margin-bottom:0.45rem;' +
    '}' +
    '.egm-wiifm-text{' +
      'font-size:0.875rem;color:rgba(255,255,255,0.78);' +
      'line-height:1.62;margin:0;' +
    '}' +

    /* ── Benefit icon ── */
    '.egm-benefit-icon{' +
      'width:1.875rem;height:1.875rem;border-radius:9999px;' +
      'background:rgba(34,197,94,0.12);' +
      'border:1px solid rgba(34,197,94,0.28);' +
      'display:flex;align-items:center;justify-content:center;flex-shrink:0;' +
    '}' +

    /* ── Section label ── */
    '.egm-section-label{' +
      'font-size:0.625rem;font-weight:900;letter-spacing:0.13em;' +
      'text-transform:uppercase;color:rgba(255,255,255,0.32);' +
      'margin-bottom:0.55rem;' +
    '}' +

    /* ── Synergy block ── */
    '.egm-synergy{' +
      'background:rgba(255,255,255,0.04);' +
      'border-radius:0.625rem;' +
      'padding:0.875rem 1rem;margin-bottom:1rem;' +
    '}' +
    '.egm-synergy-text{' +
      'font-size:0.84rem;color:rgba(255,255,255,0.62);' +
      'line-height:1.62;margin:0;font-style:italic;' +
    '}' +

    /* ── Ingredient chips ── */
    '.egm-ing-chips{display:flex;flex-wrap:wrap;gap:0.35rem;}' +
    '.egm-ing-chip{' +
      'font-size:0.7rem;font-weight:500;' +
      'padding:0.22rem 0.6rem;border-radius:9999px;' +
      'background:rgba(255,255,255,0.07);' +
      'border:1px solid rgba(255,255,255,0.11);' +
      'color:rgba(255,255,255,0.62);' +
    '}' +

    /* ── Science modal content ── */
    '.egm-sci-hd{' +
      'border-bottom:1px solid rgba(255,255,255,0.08);' +
      'padding-bottom:0.875rem;margin-bottom:1rem;' +
      'padding-right:2.5rem;' +
    '}' +
    '.egm-sci-title{' +
      'font-size:1.35rem;font-weight:800;color:#fff;' +
      'margin:0;line-height:1.25;' +
    '}' +
    '.egm-sci-body{' +
      'font-size:0.9rem;color:rgba(255,255,255,0.70);line-height:1.72;' +
    '}';

  document.head.appendChild(s);

  /* ── Helpers ──────────────────────────────────────────────────── */
  var CLOSE_BTN =
    '<button class="egm-close" aria-label="Close">' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="2.5"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<line x1="18" y1="6" x2="6" y2="18"/>' +
    '<line x1="6" y1="6" x2="18" y2="18"/>' +
    '</svg></button>';

  function esc(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function hexToRgba(hex, a) {
    if (!hex || hex.charAt(0) !== '#') return 'rgba(96,165,250,' + a + ')';
    var h = hex.replace('#', '');
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    return 'rgba(' + parseInt(h.slice(0,2),16) + ',' +
                     parseInt(h.slice(2,4),16) + ',' +
                     parseInt(h.slice(4,6),16) + ',' + a + ')';
  }

  /* ── Content renderers ────────────────────────────────────────── */
  function moleculeHTML(d) {
    var img = '';
    if (d.imageUrl) {
      var bg   = 'rgba(7,10,18,1)';
      var glow = hexToRgba(d.color || '#60a5fa', 0.24);
      /* Dark overlay dissolve — fades image into container bg from all edges.
         No CSS mask needed: the overlay matches the container background exactly,
         creating a seamless blend regardless of image shape or aspect ratio. */
      var overlayBg =
        'radial-gradient(ellipse 76% 78% at 50% 54%,' +
        'transparent 30%,rgba(7,10,18,0.44) 55%,rgba(7,10,18,0.87) 75%,rgba(7,10,18,1) 100%),' +
        'linear-gradient(to bottom,rgba(7,10,18,1) 0%,transparent 14%,transparent 84%,rgba(7,10,18,1) 100%)';
      img =
        '<div style="position:relative;width:100%;height:13rem;overflow:hidden;' +
        'border-radius:1.5rem 1.5rem 0 0;' +
        'background:radial-gradient(ellipse 96% 88% at 50% 54%,' + glow + ' 0%,' + bg + ' 72%);">' +
        '<img src="' + esc(d.imageUrl) + '" alt="' + esc(d.imageAlt || d.name) + '"' +
        ' decoding="async"' +
        ' style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;">' +
        '<div style="position:absolute;inset:0;pointer-events:none;background:' + overlayBg + '"></div>' +
        '</div>';
    }
    var dot = d.color
      ? '<span class="egm-dot" style="background:' + esc(d.color) +
        ';box-shadow:0 0 8px ' + esc(d.color) + '60"></span>'
      : '';
    var wiifm = d.wiifm
      ? '<div class="egm-wiifm">' +
        '<div class="egm-wiifm-label">What\'s In It For Me?</div>' +
        '<p class="egm-wiifm-text">' + esc(d.wiifm) + '</p>' +
        '</div>'
      : '';
    return img +
      '<div class="egm-inner">' + CLOSE_BTN +
      '<div class="egm-header">' + dot +
      '<h2 class="egm-title">' + esc(d.name) + '</h2>' +
      '</div>' +
      '<p class="egm-desc">' + esc(d.description) + '</p>' +
      wiifm + '</div>';
  }

  function benefitHTML(d) {
    var ingredients = Array.isArray(d.ingredients) ? d.ingredients : [];
    var syn = d.synergy
      ? '<div class="egm-synergy">' +
        '<div class="egm-section-label">Why It Works</div>' +
        '<p class="egm-synergy-text">' + esc(d.synergy) + '</p>' +
        '</div>'
      : '';
    var chips = ingredients.length
      ? '<div style="margin-top:1rem">' +
        '<div class="egm-section-label">Key Ingredients</div>' +
        '<div class="egm-ing-chips">' +
        ingredients.map(function (k) {
          return '<span class="egm-ing-chip">' +
            esc(k.replace(/_[A-Za-z]+$/, '')) + '</span>';
        }).join('') +
        '</div></div>'
      : '';
    return '<div class="egm-inner">' + CLOSE_BTN +
      '<div class="egm-header">' +
      '<div class="egm-benefit-icon">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"' +
      ' fill="none" stroke="#22c55e" stroke-width="2.5"' +
      ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="20 6 9 17 4 12"/></svg>' +
      '</div>' +
      '<h2 class="egm-title">' + esc(d.name) + '</h2>' +
      '</div>' +
      '<p class="egm-desc">' + esc(d.desc) + '</p>' +
      syn + chips + '</div>';
  }

  function scienceHTML(d) {
    var borderColor = d.borderColor || 'rgba(96,165,250,0.7)';
    return '<div class="egm-inner">' + CLOSE_BTN +
      '<div class="egm-sci-hd" style="border-left:3px solid ' + esc(borderColor) +
      ';padding-left:0.875rem">' +
      '<h2 class="egm-sci-title">' + esc(d.title) + '</h2>' +
      '</div>' +
      '<p class="egm-sci-body">' + esc(d.body) + '</p>' +
      '</div>';
  }

  /* ── EGModals ─────────────────────────────────────────────────── */
  window.EGModals = {
    _kb: null,

    open: function (id, data, type) {
      var overlay = document.getElementById(id);
      var panel   = overlay && overlay.querySelector('.eg-modal-panel');
      if (!overlay || !panel) return;

      /* Render */
      if      (type === 'molecule') panel.innerHTML = moleculeHTML(data);
      else if (type === 'benefit')  panel.innerHTML = benefitHTML(data);
      else if (type === 'science')  panel.innerHTML = scienceHTML(data);

      /* Color token — drives WIIFM accent and ambient glow */
      if (data && data.color) {
        panel.style.setProperty('--mc', data.color);
        if (type === 'molecule') {
          panel.style.boxShadow =
            '0 0 52px ' + hexToRgba(data.color, 0.09) +
            ', 0 24px 64px rgba(0,0,0,0.72)';
        }
      }
      if (data && data.borderColor && type === 'science') {
        panel.style.setProperty('--mc', data.borderColor);
      }

      /* Close button */
      var closeBtn = panel.querySelector('.egm-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () { window.EGModals.close(id); });
      }

      /* Backdrop click */
      function onBd(e) { if (e.target === overlay) window.EGModals.close(id); }
      overlay._egbd = onBd;
      overlay.addEventListener('click', onBd);

      /* Escape key */
      this._kb = function (e) { if (e.key === 'Escape') window.EGModals.close(id); };
      document.addEventListener('keydown', this._kb);

      /* Show */
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close: function (id) {
      var overlay = id
        ? document.getElementById(id)
        : document.querySelector('.eg-modal-overlay.is-open');
      if (!overlay) return;
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (overlay._egbd) { overlay.removeEventListener('click', overlay._egbd); overlay._egbd = null; }
      if (this._kb)       { document.removeEventListener('keydown', this._kb); this._kb = null; }
    }
  };

})();
